/**
 * Hook dịch của kho — **chỗ duy nhất** component gọi để lấy chữ.
 *
 * Bọc `useTranslation` của react-i18next thay vì dùng trực tiếp, vì hai việc
 * mà bản trần không làm được:
 *
 * 1. **Khoá có kiểu.** `t` ở đây chỉ nhận `KhoaDich`, nên `t('tenant.tieuDee')`
 *    là lỗi `tsc`. Dùng `useTranslation` trần thì khoá là `string` tự do và lỗi
 *    chính tả chỉ lộ ra thành một nhãn hiện nguyên chuỗi khoá trên giao diện.
 * 2. **Một chỗ để đổi.** Nếu sau này bỏ react-i18next (ADR-UI-0003 từng bỏ
 *    next-intl một lần rồi), chỗ phải sửa là tệp này, không phải 95 tệp view.
 *
 * ❌ Không `import { useTranslation } from 'react-i18next'` trong `components/`
 * hay `modules/` — `check:i18n` chặn.
 */
import { useTranslation } from 'react-i18next';

import type { KhoaDich } from './types';
import type { NgonNgu } from './config';
import { MA_LOCALE } from './config';

/** Tham số nội suy của một chuỗi: `{{so}}`, `{{ten}}`… */
export type ThamSoDich = Record<string, string | number>;

export interface BoDich {
  /** Dịch một khoá. Khoá sai là lỗi biên dịch. */
  t: (khoa: KhoaDich, thamSo?: ThamSoDich) => string;
  /** Ngôn ngữ đang hiển thị. */
  ngonNgu: NgonNgu;
  /** Locale cho `Intl` và `toLocaleString`: `vi-VN` hoặc `en-GB`. */
  locale: string;
}

export function useT(): BoDich {
  const { t, i18n } = useTranslation();
  const ngonNgu = i18n.language as NgonNgu;

  return {
    t: (khoa, thamSo) => t(khoa, thamSo ?? {}),
    ngonNgu,
    locale: MA_LOCALE[ngonNgu] ?? MA_LOCALE.vi,
  };
}
